
// import { actionTypes } from "./actions";
import { getFnstrListAPI } from './endpoints';
import { actions } from 'store/Reducer/actions';

export const actionTypes = {
    FNSTR_GET_REQUEST: "FNSTR_GET_REQUEST",
    FNSTR_GET_RECEIVE: "FNSTR_GET_RECEIVE",
    FNSTR_GET_FAIL: "FNSTR_GET_FAIL"
  };

const requestFnstr = () => ({
    type: actionTypes.FNSTR_GET_REQUEST,
});
const receivetFnstr = (payload) => ({
    type: actionTypes.FNSTR_GET_RECEIVE,
    payload,
});
const failuretFnstr = (payload) => ({
    type: actionTypes.FNSTR_GET_FAIL,
    payload,
});



export const gettFnstrAction = () => {
    return async (dispatch) => {
        dispatch(requestFnstr());
        try {
            const response = await getFnstrListAPI();
            if (response?.status === 200) {
                dispatch(receivetFnstr(response?.data?.data));
                // dispatch(actions.successAlert("Coutries fetched successfully"));
            }
        } catch (error) {
            dispatch(failuretFnstr(error?.response?.data?.data));
            if (error?.response) {
                dispatch(actions.errorAlert(error?.response?.data?.errorMessage));
            } else {
                 dispatch(actions.errorAlert( "Something went wrong, please contact administrator"));
            }
        }
    };
};

